export const MARKET_ACTION_TIMEOUT_MS = 20_000;
export const MARKET_READ_TIMEOUT_MS = 10_000;

export const marketReadTimeout = (recoveryDeadlineAt?: number): number =>
  recoveryDeadlineAt === undefined
    ? MARKET_READ_TIMEOUT_MS
    : Math.max(0, recoveryDeadlineAt - Date.now());
